const appIcons = {
  // Koachify
  koachifyexploreIcon: '\ue902',
  mycoursesIcon: '\ue907',
  liveclassesIcon: '\ue903',
  mysessionsIcon: '\ue904',

  // Eventify
  eventifyexploreIcon: '\ue905',
  sessionsIcon: '\ue909',
  exhibitorsIcon: '\ue911',
  sponsorsIcon: '\ue916',
  speakersIcon: '\ue915',
  myagendaIcon: '\ue910',
  surveyIcon: '\ue917',
  galleryIcon: '\ue912',
  communityIcon: '\ue900',
  mapsIcon: '\ue913',
  newsIcon: '\ue914',
  bookmarksIcon: '\ue904',
  ticketIcon: '\ue90b',
  socialIcon: '\ue920',
  gamificationIcon: '\ue91f',
  notesIcon: '\ue921',
  webviewIcon: '\ue922',

  // Common
  profileIcon: '\ue908',
  attendeesIcon: '\ue918',
  chatIcon: '\ue901',
  pollsIcon: '\ue906',
  loginIcon: '\ue92f',
  logoutIcon: '\ue930',
  searchIcon: '\ue931',
  qrScanIcon: '\ue932',
  syncIcon: '\ue933',

  // promo
  locationPinIcon: '\ue934',
  scheduleIcon: '\ue935',

  // Icons
  downloadIcon: '\ue90a',
  fileDefaultIcon: '\ue90c',
  fileDocumentIcon: '\ue90d',
  fileImageIcon: '\ue90e',
  uploaderIcon: '\ue90f',
  messageIcon: '\ue91a',
  tickIcon: '\ue91b',
  letsmeetIcon: '\ue919',
  envalopIcon: '\ue91c',
  bookmarkOutlineIcon: '\ue91e',
  filterIcon: '\ue91d',
  circleTickIcon: '\ue91b',
  calenderDarkIcon: '\ue909',
  calenderIcon: '\ue910',
  photoIcon: '\ue912',
  crossCircleIcon: '\uea0d',
  blockedIcon: '\uea0e',
  trashIcon: '\ue906',
  viewEyeicon: '\ue924',
  bellIcon: '\ue925',
  timerIcon: '\ue926',
  lockerIcon: '\ue927',
  eventGuideIcon: '\ue902',
  tiltedAttachmentIcon: '\ue9cd',
  pdfIcon: '\ueadf',
  gearIcon: '\ue994',
  starIcon: '\ue923',
  thumbsupIcon: '\ue928',
  invertedTrashIcon: '\ue929',
  crossIcon: '\ue92a',
  briefcaseIcon: '\ue92b',
  officeIcon: '\ue92c',
  sessionCalenderIcon: '\ue92d',
  homeIcon: '\ue92e'
};

export default appIcons;
